module.exports = __webpack_public_path__ + "static/media/kaggleLogo.b092e40d.webp";